export const MEDIA_DISPLAY_DURATION_MIN_SECONDS = 1;
export const MEDIA_DISPLAY_DURATION_MAX_SECONDS = 60;
export const PROMOTIONAL_VIDEO_MAX_BYTES = 50 * 1024 * 1024;
export const PROMOTIONAL_IMAGE_MAX_BYTES = 10 * 1024 * 1024;

export function normalizeMediaDisplayDuration(value: number, fallback = 8): number {
  const candidate = Number.isFinite(value) ? Math.round(value) : fallback;
  return Math.min(
    MEDIA_DISPLAY_DURATION_MAX_SECONDS,
    Math.max(MEDIA_DISPLAY_DURATION_MIN_SECONDS, candidate),
  );
}

export function getMediaTitle(title: string | null | undefined, fallback: string): string {
  const normalizedTitle = title?.trim();
  const normalizedFallback = fallback.trim() || "Mídia promocional";
  return (normalizedTitle || normalizedFallback).slice(0, 128);
}

export function getPromotionalMediaSizeError(type: "image" | "video", sizeInBytes: number): string | null {
  const maxBytes = type === "video" ? PROMOTIONAL_VIDEO_MAX_BYTES : PROMOTIONAL_IMAGE_MAX_BYTES;
  if (sizeInBytes <= maxBytes) return null;
  const limitInMb = Math.round(maxBytes / 1024 / 1024);
  return type === "video"
    ? `Este vídeo tem ${(sizeInBytes / 1024 / 1024).toFixed(1)} MB. Envie uma versão de até ${limitInMb} MB para o Painel de TV.`
    : `Esta imagem tem ${(sizeInBytes / 1024 / 1024).toFixed(1)} MB. Envie uma versão de até ${limitInMb} MB.`;
}
